import React from 'react';
import { Icon, Tooltip, Whisper } from 'rsuite';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { LoadingSpinerLocal } from '../../../../../../components/LoadingSpinner';
import styles from './CoberturaTotalChart.module.scss';
import { BigNumbersType } from '../../types';

export type CoberturaTotalProps = {
  className?: string;
  data?: BigNumbersType;
  isLoading?: boolean;
};

export const CoberturaTotal = ({ className, data, isLoading }: CoberturaTotalProps) => {
  const coberturaTotal: number | undefined | null = data?.coberturaTotal;
  const noValue = coberturaTotal === undefined || coberturaTotal < 0 || coberturaTotal === null;
  const elasticityValue = noValue ? 0 : coberturaTotal;

  const graficoData = {
    exporting: {
      enabled: false,
    },
    chart: {
      type: 'gauge',
      backgroundColor: 'transparent',
      height: 280,
    },
    title: {
      text: '',
    },
    pane: {
      startAngle: -90,
      endAngle: 89.9,
      background: null,
      center: ['50%', '75%'],
      size: '100%',
    },
    plotOptions: {
      gauge: {
        wrap: false,
      },
    },
    yAxis: {
      min: 0,
      max: 100,
      tickInterval: 20,
      tickLength: 125,
      tickWidth: 0,
      minorTickInterval: null,
      labels: {
        distance: 12,
        style: {
          fontSize: '10px',
        },
        formatter() {
          const label = this.axis.defaultLabelFormatter.call(this);
          return `${label}%`;
        },
      },
      plotBands: [
        {
          from: 0,
          to: 20,
          color: '#D7E8FC',
          thickness: 20,
        },
        {
          from: 20,
          to: 40,
          color: '#A5CCF8',
          thickness: 20,
        },
        {
          from: 40,
          to: 60,
          color: '#559FF2',
          thickness: 20,
        },
        {
          from: 60,
          to: 80,
          color: '#2680EB',
          thickness: 20,
        },
        {
          from: 80,
          to: 100,
          color: '#0D66D0',
          thickness: 20,
        },
      ],
    },
    tooltip: {
      enabled: false,
    },
    series: [
      {
        data: [elasticityValue],
        dataLabels: {
          y: 100,
          borderWidth: 0,
          padding: 14,
          color: '#323232',
          style: {
            fontSize: '32px',
            fontWeight: '300',
            fontFamily: 'Open Sans',
            fontStyle: 'normal',
          },
          formatter() {
            const number = this.y.toString().replace('.', ',');
            return `${number}%`;
          },
        },
        dial: {
          radius: '65%',
          backgroundColor: '#505050',
          baseWidth: 12,
          baseLength: '0%',
          rearLength: '0%',
        },
        pivot: {
          backgroundColor: '#505050',
          radius: 6,
        },
      },
    ],
  };

  return (
    <div className={`${styles['cobertura-total-box']} ${className}`}>
      <LoadingSpinerLocal loading={isLoading} size="md" />
      <div className={styles['title-wrapper']}>
        <p className={styles.title}>Cobertura total de produtos</p>
        <Whisper
          trigger="hover"
          speaker={
            <Tooltip>
              O índice de cobertura total representa quantos dos seus produtos de interesse estão cobertos por dados do Infopanel. Consideramos o produto
              coberto quando temos dados em uma ou mais lojas dos pontos de interesse selecionados.
            </Tooltip>
          }
        >
          <Icon className={styles.icon} icon="info" />
        </Whisper>
      </div>
      <div className={styles['gauge-chart-container']}>
        <HighchartsReact highcharts={Highcharts} options={graficoData} />
      </div>
      <div className={styles['bottom-text-wrapper']}>
        <p className={styles['regular-text']}>correspondem à sua cobertura total de produtos.</p>
      </div>
    </div>
  );
};
